import saveAs from 'file-saver';
import React from 'react';
import axios from '../../../config/axiosConfig';
import { ControlDict } from '../../../redux/controls/models';
import { DownloadResponse } from '../../../redux/queryResults/models';
import { PublishTestRequest } from './PublishTestPanel.interfaces';
import { IValidationResult, IValidationResultResponse, ValidationItems } from './PublishTestPanel.interfaces';
import { DeepLinkResponse } from './PublishTestPanel.interfaces';
import { ErrorResponse } from '../../../shared';
import { VALIDATION_CALL_TYPE } from './PublishTestPanel.types';

export interface DeepLinkRequest {
  ItemTableIDs: number[];
  LoggedInUsername: string;
  CurrentApplicationURL: string;
}

export const publishTestAsync = async(
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setModalContent: React.Dispatch<React.SetStateAction<string>>,
  controls: ControlDict|null,
  publishTestObj?: PublishTestRequest,
): Promise<void> => {
  let response = {} as DownloadResponse;
  try {
    await axios.post<Blob>('api/TestPublish/Publish', {...publishTestObj}, {responseType: 'blob'})
      .then(res => {
        response = {blob: res.data, headers: res.headers};
      });

    const fileNameStr = response.headers['content-disposition'] as string;
    const fileName = fileNameStr.substring(
      fileNameStr.indexOf('"') + 1,
      fileNameStr.indexOf('"', fileNameStr.indexOf('"') + 1)
    );
    const fileType = { type: response.headers['content-type'] } as BlobPropertyBag;
    const blob = new Blob([response.blob], fileType);
    saveAs(blob, fileName);
    setModalContent(
      controls?.PubTestEmailBody?.controlText ?
        controls?.PubTestEmailBody?.controlText :
        'Success'
    );
    setIsModalOpen(true);
  } catch (err) {
    setModalContent(err as string);
    setIsModalOpen(true);
  }
};

export const tabToSelectView = (e: KeyboardEvent): void => {
  if (e.key === 'Tab' && !e.shiftKey) {
    const selectedSwitchViewButton = document.getElementById('switch-view-qv') as HTMLElement;
    if (selectedSwitchViewButton) {
      e.preventDefault();
      selectedSwitchViewButton.focus();
    }
  }
};

export function isValidationResult(result: IValidationResultResponse | ErrorResponse):
   result is IValidationResultResponse {
  return (result as IValidationResultResponse).__typename === 'ValidationResultResponse';
}

export const getValidationResult = async (itemslist: ValidationItems, validationCallType: VALIDATION_CALL_TYPE, abortController: AbortController):
 Promise<IValidationResultResponse | ErrorResponse> => {
  const body = {ItemTableIDList: itemslist, ValidationCallType: validationCallType};

  const response = await axios.post<IValidationResult>(
    '/api/testpublish/selectionvalidation',
    body,
    { signal: abortController.signal}).then(
    (response): IValidationResultResponse => (
      {
        validationResult: response.data,
        __typename: 'ValidationResultResponse'
      }
    )
  ).catch((error) => {
    return { __typename: 'ErrorResponse', errMsg: error.message };
  });

  return response;
};

export const createDeepLinkAsync = async (request: DeepLinkRequest): Promise<DeepLinkResponse> => {
  const response = await axios.post<DeepLinkResponse>('api/DeepLink', { ...request });
  return response.data;
};